import React from 'react';
import {
  Wrapper,
  Image,
} from '../common';
import { toKebabCase } from '../../util/helpers';
import './PostImage.scss';

const PostImage = (props) => {
  const {
    data,
  } = props;
  const {
    primary,
  } = data;
  const {
    image,
    imageCaption,
    imageStyle,
  } = primary;
  const classes = `image-style-${toKebabCase(imageStyle)}`;
  return (
    <section className={`post-image ${classes}`}>
      <Wrapper className="image-wrapper" isBound>
        <div className="image-container">
          <Image image={image} className={imageStyle.toLowerCase()} />
        </div>
      </Wrapper>
      { imageCaption && imageCaption.text && (
        <Wrapper className="caption-wrapper" isBound>
          <span className="caption">{imageCaption.text}</span>
        </Wrapper>
      )}
    </section>
  );
};

export default PostImage;
